import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Pagination, Spin } from 'antd';
import useDefaultRequest from '../hooks/useDefaultRequest';

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;

const DEFAULT_PAGE_SIZE = 10;

export default function PaginatedList({
    children,
    request = {},
    pageSize = DEFAULT_PAGE_SIZE,
    showTotal = true,
    emptyComponent = null
}) {
    const {
        url,
        params = {},
        dataDefault = [],
        dependence = []
    } = request;

    const [currentPage, setCurrentPage] = useState(1);

    const { data, response, isLoading } = useDefaultRequest({
        url,
        params: {
            ...params,
            page: currentPage,
            page_size: pageSize
        },
        hasPagination: true,
        dataDefault,
        dependence: [...dependence, currentPage]
    });

    const total = response?.data?.count || 0;

    // Reset para página 1 quando os filtros mudam
    useEffect(() => {
        setCurrentPage(1);
    }, [...dependence]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (isLoading) {
        return (
            <LoadingWrapper>
                <Spin size="large" />
            </LoadingWrapper>
        );
    }

    if (data.length === 0) {
        return emptyComponent;
    }

    return (
        <>
            {children(data)}

            {total > pageSize && (
                <PaginationWrapper>
                    <Pagination
                        current={currentPage}
                        total={total}
                        pageSize={pageSize}
                        onChange={handlePageChange}
                        hideOnSinglePage={true}
                        showSizeChanger={false}
                        showTotal={showTotal
                            ? (total, range) => `${range[0]}-${range[1]} de ${total} itens`
                            : undefined
                        }
                    />
                </PaginationWrapper>
            )}
        </>
    );
}
